<svg xmlns="http://www.w3.org/2000/svg" viewBox="4 4 24 24">
  <path d="M9,9V28H28V9ZM26,26H11V11H26Z"/>
  <polygon points="21 4 4 4 4 21 6 21 6 6 21 6 21 4"/>
</svg>
